import { BaseToolConfig, ToolKind, ToolTrigger } from 'shared/interfaces/tools/Tool';

export interface FollowUpToolConfig extends BaseToolConfig {
  kind: ToolKind.FOLLOW_UP;
  toolName: ToolKind.FOLLOW_UP;
  trigger: ToolTrigger.SCHEDULED;
  instructions: string;
  intervalMs: number;
}

export enum FollowUpIntervalMsOptions {
  TWO_HOURS = 7200000,
  EIGHT_HOURS = 28800000,
  EIGHTEEN_HOURS = 64800000
}
